import { render, staticRenderFns } from "./ApplyToBackgroundColor.vue?vue&type=template&id=d42686a8"
import script from "./ApplyToBackgroundColor.vue?vue&type=script&lang=js"
export * from "./ApplyToBackgroundColor.vue?vue&type=script&lang=js"
import style0 from "./ApplyToBackgroundColor.vue?vue&type=style&index=0&id=d42686a8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d42686a8')) {
      api.createRecord('d42686a8', component.options)
    } else {
      api.reload('d42686a8', component.options)
    }
    module.hot.accept("./ApplyToBackgroundColor.vue?vue&type=template&id=d42686a8", function () {
      api.rerender('d42686a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/ApplyToBackgroundColor.vue"
export default component.exports